import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { CREATIVE_TYPES } from 'app/constants/BibConstants';

export const graphLinkedItemShape = ImmutablePropTypes.mapContains({
  '@graph': ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      '@context': PropTypes.oneOf(['http://schema.org']).isRequired,
      '@type': PropTypes.oneOf(['ItemList', 'Product', 'Event', ...Object.values(CREATIVE_TYPES)]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired
});

export const breadcrumbListLinkedDataShape = ImmutablePropTypes.mapContains({
  '@context': PropTypes.string.isRequired,
  '@type': PropTypes.oneOf(['BreadcrumbList']).isRequired,
  itemListElement: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      '@type': PropTypes.oneOf(['ListItem']).isRequired,
      position: PropTypes.number.isRequired,
      item: ImmutablePropTypes.mapContains({
        '@id': PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    })
  ).isRequired
});

export default PropTypes.oneOfType([breadcrumbListLinkedDataShape, graphLinkedItemShape]);
